<template>
  <v-layout>
    <v-flex xs12>
      <BaseToolbar :title="$t('organization.form.title_edit')" type-title="icon" icon="edit" :button-save="true"
        @close="closeDrawerOrgEdit" @save="save" />
      <v-layout wrap pa-5 style="overflow-y: auto">
        <v-flex xs12>
          <v-card class="afrus-d-rounded-card mt-5">
            <v-card-title primary-title>
              <h5>
                {{ $t('organization.form.org_data') }}
              </h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs11 ml-3>
                  <v-text-field v-model="localOrg.name" v-validate="'required'" data-vv-name="name" required
                    :label="$t('organization.table.org_name')" :error-messages="errors.collect('name')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs11 ml-3>
                  <v-text-field v-model="localOrg.url" v-validate="'required|url'" data-vv-name="url" required
                    :error-messages="errors.collect('url')" :label="$t('organization.org_url')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field v-model="localOrg.contact_name" v-validate="'required'" data-vv-name="contact_name"
                    required :error-messages="errors.collect('contact_name')"
                    :label="$t('organization.table.org_contact_name')"></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field v-model="localOrg.contact_info" v-validate="'required|email'" data-vv-name="contact_info"
                    required :error-messages="errors.collect('contact_info')"
                    :label="$t('organization.table.org_contact_info')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete v-model="localOrg.country_id" v-validate="'required'" :items="countries"
                    :error-messages="errors.collect('country_id')" item-text="name" item-value="id" required
                    data-vv-name="country_id" :label="$t('profile.profile.country')" />
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field v-model="localOrg.city" v-validate="'required'" data-vv-name="city" required
                    :error-messages="errors.collect('city')" :label="$t('organization.org_city')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3 mb-5>
                  <v-text-field v-model="localOrg.zip_code" v-validate="'required'" data-vv-name="zip_code" required
                    :error-messages="errors.collect('zip_code')" :label="$t('organization.org_zip_code')"></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field v-model="localOrg.legal_document" v-validate="'required'" data-vv-name="legal_document"
                    required :error-messages="errors.collect('legal_document')"
                    :label="$t('organization.org_legal_document')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field v-model="localOrg.phone" v-validate="{
                    regex: /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/
                  }" data-vv-name="phone" required :error-messages="errors.collect('phone')"
                    :label="$t('organization.table.org_phone')"></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-autocomplete v-model="localOrg.currency_id" :items="currencies" v-validate="'required'"
                    data-vv-name="currency_id" :error-messages="errors.collect('currency_id')" item-text="code" required
                    item-value="id" :label="$t('organization.org_currency')" />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field v-model="localOrg.subdomain" label="Subdominio"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete  :items="classifications" data-vv-name="classification_id" item-text="type" item-value="id"  v-model="localOrg.classification_id"
                    label="Clasificacion"></v-autocomplete>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-select
                  :items="['Instagram', 'Facebook','Twitter', 'LinkedIn', 'Web', 'Other']"
                    v-model="localOrg.source"
                    label="Source"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"
import BaseToolbar from '@/components/BaseToolbar'

export default {
  components: {
    BaseToolbar
  },
  watch: {
    organization(newVal, oldVal) {
      if (newVal.id) {
        this.localOrg = JSON.parse(JSON.stringify(newVal))
      }
    }
  },
  data() {
    return {
      localOrg: {}
    }
  },
  methods: {
    ...mapActions({
      updateOrganization: 'organization/updateOrganization'
    }),
    ...mapMutations({
      organizationDrawerEdit: 'organization/organizationDrawerEdit'
    }),
    closeDrawerOrgEdit() {
      this.organizationDrawerEdit(false)
    },
    async save() {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        console.log({classification: this.localOrg.classification_id})
        this.updateOrganization({
          id: this.localOrg.id,
          body: {
            name: this.localOrg.name,
            url: this.localOrg.url,
            contact_name: this.localOrg.contact_name,
            contact_info: this.localOrg.contact_info,
            phone: this.localOrg.phone,
            country_id: this.localOrg.country_id,
            city: this.localOrg.city,
            zip_code: this.localOrg.zip_code,
            legal_document: this.localOrg.legal_document,
            currency_id: this.localOrg.currency_id,
            subdomain: this.localOrg.subdomain,
            classification_id: this.localOrg.classification_id,
            source: this.localOrg.source,
          }
        })
          .then(
            res => {
              this.$noty.success(this.$t('organization.success_updated'))
            },
            err => {
              this.$noty.error(this.$t('organization.error_updated'))
              console.log(err)
            }
          )
      }
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      currencies: ({ countries: { currencies } }) => currencies,
      countries: ({ countries: { countries } }) => countries,
      classifications: ({ organization: { classifications } }) => classifications,
    })
  }
}
</script>

<style></style>